'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import getCountryName from './getCountryName';
import sortOptions from './sortOptions';
import CountryFlag from '../../components/CountryFlag';
let allCountryOptions = [];

const getCountriesByCode = () => {
  // Should return uppercase language codes and their translations
  return I18n.text('SharedI18nStrings.countryCodes');
};

const buildCountryOption = countryCode => {
  const iso2 = countryCode.toLowerCase();
  return {
    text: getCountryName(iso2),
    value: iso2,
    avatar: /*#__PURE__*/_jsx(CountryFlag, {
      countryCode: iso2
    })
  };
};

export const getCountryOptions = ({
  optionsFilter
} = {}) => {
  if (!optionsFilter && allCountryOptions.length) {
    return allCountryOptions;
  } else if (optionsFilter && allCountryOptions.length) {
    return allCountryOptions.filter(optionsFilter);
  }

  allCountryOptions = Object.keys(getCountriesByCode()).map(code => buildCountryOption(code)).sort(sortOptions);

  if (optionsFilter) {
    return allCountryOptions.filter(optionsFilter);
  }

  return allCountryOptions;
};
export const getOptionsForValidCountries = ({
  validCountries,
  optionsFilter
}) => {
  let options = [];
  const countriesByCode = getCountriesByCode();
  validCountries.forEach(countryCode => {
    if (countriesByCode[countryCode.toUpperCase()]) {
      options.push(buildCountryOption(countryCode));
    }
  });

  if (optionsFilter) {
    options = options.filter(optionsFilter);
  }

  return options.sort(sortOptions);
};